import _ from 'lodash';
export default {
    data () {
        return {

        };
    },
    methods: {
        downloadPdf (taskId, type, date, download) {
            let pre = location.href.slice(0, -location.hash.length);
            if (location.href.indexOf('localhost') !== -1
                || location.href.indexOf('127.0.0.1') !== -1) {
                pre += 'modelstore/';
            }
            //判断线上环境
            if (location.href.indexOf('gzzoc-modelstore') !== -1) {
                pre += 'modelstore/';
            }
            const routeParams = {
                type: type,
                taskId: taskId,
                date: date,
                explain: 'none',
                lang: this.$i18n.locale
            };
            let localData = '{}';
            const path =  pre + this.$router.resolve({
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    ...routeParams
                }
            }).href;
            download.loading = true;
            this.$http.post('webshot/pdf', localData, {
                params: {
                    url: path,
                    selector: '.capture-dom',
                    header: '<div>' + date + '</div>',
                    footer: '<div></div>',
                    format: 'A4'
                }
            }).then((resp) => {
                download.loading = false;
                if (_.get(resp, 'body.code') !== 0) {
                    this.$message.error(_.get(resp, 'body.message'));
                    return;
                }
                const id = _.get(resp, 'body.data[0]._id');
                const vm = this;
                if (id) {
                    const win = window.open(location.origin + `/api/upl/s3/show?_id=${id}`, '_blank');
                    if (!win) {
                        return this.$alert('浏览器拦截了弹窗，请在地址栏右侧设置允许显示弹出式窗口；', '提示', {
                            callback: () => {}
                        });
                    }
                }
                setTimeout(() => {
                    vm.$http.get(`upl/s3/remove?_id=${id}`);
                }, 1000);
            }).finally(() => {
                download.loading = false;
            });
        }
    }
};